import React from 'react';
import { View } from 'react-native-web';
import {
  Bank_name_str, phone_number_one, phone_number_zero, Phone_str, select_contacts_title, userInitialsNameSD, userNameSD,
} from '../../../../../utils/DictionaryManagementUtils';
import MyContactLine from '../../../../ContactList/MyContactLine';
import FullPageSimulator from '../../FullPageSimulator';
import SearchContactHeadLine from '../../../../ContactList/SearchContactHeadLine';

//= ========================================================================

const SearchContactFP = ({
  globJSON,
  simPlatform,
  subCategoryId,
  slideshowRefs,
  headlineText = select_contacts_title,
  text,
}) => {
  const { border_light_color } = globJSON.configurations.theme.colors;
  const myStyles = {
    breakLine: {
      width: 240,
      height: 1,
      backgroundColor: border_light_color,
    },
    margin: {
      marginTop: 5,
    },
  };
  return (
    <FullPageSimulator
      globJSON={globJSON}
      simPlatform={simPlatform}
      withExtraHeightForTitle
      headlineText={headlineText}
      withOutPadding
      slideshowRefs={slideshowRefs}
    >
      <View style={myStyles.margin}>
        <SearchContactHeadLine globJSON={globJSON} subCategoryId={subCategoryId} simPlatform={simPlatform} text={text} textBlack withCloseIcon />
      </View>
      <View>
        <MyContactLine
          simPlatform={simPlatform}
          globJSON={globJSON}
          txtInitials={userInitialsNameSD}
          txtPrimary={userNameSD}
          withAvatar={globJSON.configurations.general.show_avatar_in_contact_lists}
          avatarColor={globJSON.configurations.theme.colors.avatar_color_1}
          withCollapse
        />
        <MyContactLine
          simPlatform={simPlatform}
          globJSON={globJSON}
          txtInitials={userInitialsNameSD}
          txtPrimary={Bank_name_str}
          txtSecondary={phone_number_one}
          withAvatar={globJSON.configurations.general.show_avatar_in_contact_lists}
          emptyBackground
        />
        <MyContactLine
          simPlatform={simPlatform}
          globJSON={globJSON}
          txtInitials={userInitialsNameSD}
          txtPrimary={Phone_str}
          txtSecondary={phone_number_zero}
          withAvatar={globJSON.configurations.general.show_avatar_in_contact_lists}
          emptyBackground
        />
        <View style={myStyles.breakLine} />
      </View>
    </FullPageSimulator>
  );
};

export default SearchContactFP;
